module.exports = "/assets/data/d0586d3a0f627e494f545c3216e795fb-LA5.data.json";